//------------------------------------------------------------------------------
// name: BranchBankSelector.tsx
// author: mudas
// created: 2025/12/09
//------------------------------------------------------------------------------

import React, { FC, useEffect, useState } from 'react';
import { useSafeQuery } from 'common/hooks';
import { useProxyValue } from 'common/components';

import service from 'common/service';
import { Identity } from 'common/types';

import { Select, SelectProps } from '@fuxi/eevee-ui';

type ValueType = string | string[];
type OptionType = Identity;
export interface IProps extends SelectProps<ValueType, OptionType> {
  bankId?: string;
  branchBankName?: string;

  // 是否返回 option 替代 value
  replaceAsOption?: boolean;
}

const BranchBankSelector: FC<IProps> = (props) => {
  const { bankId, branchBankName, replaceAsOption, value: baseValue, onChange: baseOnChange, ...otherProps } = props;

  const [bankName, setBankName] = useState<string>(branchBankName || '');

  const { value, onChange } = useProxyValue({
    fieldName: 'bankNo',
    replaceAsOption,
    value: baseValue,
    onChange: baseOnChange,
  });

  const { data, isFetching } = useSafeQuery({
    queryKey: ['getSubBankList', bankId, bankName],
    queryFn: async () => {
      const res = await service.userSetting.getSubBankList({
        bankId: bankId!,
        subBankName: bankName || undefined,
      });
      return res.data;
    },
    enabled: !!bankId,
    cacheTime: 10 * 60 * 1000,
    staleTime: 10 * 60 * 1000,
    fetchingDelay: 200,
    debounceWait: 300,
    debounceLeading: true,
  });

  useEffect(() => {
    branchBankName !== undefined && setBankName(branchBankName);
  }, [branchBankName]);

  return (
    <Select<ValueType, OptionType>
      loading={isFetching}
      options={data?.items}
      value={value}
      showSearch
      allowClear
      placeholder="请选择银行支行"
      fieldNames={{ label: 'bankName', value: 'bankNo' }}
      filterOption={false}
      onSearch={(value: string) => setBankName(value)}
      onChange={onChange}
      {...otherProps}
    />
  );
};

export default BranchBankSelector;
